// Alte satmueller.de-Pfade → neue Seiten (Landing-Sections via state.scrollTo)
export const REDIRECTS = {
    // Root / Sonstiges
    "/index.htm": "/",

    // Produkte
    "/deutsch/produkte.htm": "/produkte",
    "/deutsch/kopfstationstechnik.htm": "/produkte/kopfstationstechnik",
    "/deutsch/dh8basis.htm": "/produkte/kopfstationstechnik",
    "/deutsch/einzelumsetzer 1.htm": "/produkte/einzelumsetzer",
    "/deutsch/beheizte antennen.htm": "/produkte/antennenheizung",
    "/deutsch/beheizte antennen 85-100cm.htm": "/produkte/antennenheizung",
    "/deutsch/beheizte antennen_125cm.htm": "/produkte/antennenheizung",
    "/deutsch/antennen.htm": "/produkte/antennen",
    "/deutsch/antennen 65-100cm.htm": "/produkte/antennen",
    "/deutsch/antennen_125-240cm.htm": "/produkte/antennen",
    "/deutsch/masterfocus-antennen.htm": "/produkte/antennen",
    "/deutsch/sat-zf-verteilsysteme.htm": "/produkte/sat-zf-verteilsysteme",
    "/deutsch/spaun.htm": "/produkte/sat-zf-verteilsysteme",
    "/deutsch/jultec sat-zf 1.htm": "/produkte/sat-zf-verteilsysteme",
    "/deutsch/kathrein.htm": "/produkte/sat-zf-verteilsysteme",
    "/deutsch/johansson.htm": "/produkte/sat-zf-verteilsysteme",
    "/deutsch/fibre uebersicht.htm": "/produkte/fibre-glas",
    "/deutsch/fibre lnb.htm": "/produkte/fibre-glas",
    "/deutsch/fibre abschlusseinheit.htm": "/produkte/fibre-glas",
    "/deutsch/fibre kabel.htm": "/produkte/fibre-glas",
    "/deutsch/fibre zubehoer.htm": "/produkte/fibre-glas",
    "/deutsch/fibre messgeraet.htm": "/produkte/fibre-glas",
    "/deutsch/lnb-uebersicht.htm": "/produkte/lnb",
    "/deutsch/profi-lnb.htm": "/produkte/lnb",
    "/deutsch/standard-lnb.htm": "/produkte/lnb",
    "/deutsch/blockkonverter.htm": "/produkte/lnb",
    "/deutsch/adapter multifeed.htm": "/produkte/adapter-multifeed",
    "/deutsch/multifeedschienen.htm": "/produkte/adapter-multifeed",
    "/deutsch/adapter.htm": "/produkte/adapter-multifeed",
    "/deutsch/infomediaplayer.htm": "/produkte/infomedia",

    // Download
    "/deutsch/download.htm": "/downloads",
    "/deutsch/software.htm": "/downloads/software",
    "/deutsch/bedienungsanleitungen.htm": "/downloads/bedienungsanleitungen",
    "/pageflip/katalog_ohne preise/index.html": "/pageflip",
    "/pageflip/katalog_ohne%20preise/index.html": "/pageflip",
    "/pageflip/katalog_ohne preise/katalog_ohne preise.pdf": "/datenblaetter/katalog_ohne_preise.pdf",
    "/pageflip/katalog_ohne%20preise/katalog_ohne%20preise.pdf": "/datenblaetter/katalog_ohne_preise.pdf",

    // Startseiten-Bereiche
    "/deutsch/service.htm": { to: "/", scrollTo: "reparatur" },
    "/deutsch/kontakt.htm": { to: "/", scrollTo: "kontakt" },
    "/deutsch/haendlerzugang.htm": { to: "/", scrollTo: "haendler" },
    "/deutsch/impressum.htm": "/",
    "/deutsch/datenschutz.htm": "/",
};
